import React from 'react';
import classNames from 'classnames';

import { DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import {
  Text,
} from '../../../components';

import { ParagraphTextMedia as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphTextMediaProps {
  entity: ImmutableEntity<Type>;
}

const ParagraphTextMedia: React.FC<ParagraphTextMediaProps> = ({
  entity,
}) => {
  const paragraphTextMedia = entity.toJS();

  const title = paragraphTextMedia.field_title[0]?.value;
  const body = paragraphTextMedia.field_body[0]?.processed || '';
  const media = paragraphTextMedia.field_media_item[0];

  let posterImage;
  if (media.bundle === 'video') {
    posterImage = media.entity.field_poster_image[0]?.url;
  }

  const isLargeMedia = paragraphTextMedia.field_large_media[0]?.value;
  const useOriginalRatio = paragraphTextMedia.field_original_ratio[0]?.value;

  const mediaContainer = classNames('ParagraphTextMedia__media col-12', {
    'col-md-10 offset-md-1 col-lg-8 offset-lg-2': !isLargeMedia,
  });

  return (
    <div className="Paragraph ParagraphTextMedia">
      <Container>
        <div className="row">
          {body && (
            <div className="ParagraphTextMedia__text col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <Text
                title={title}
                text={body}
              />
            </div>
          )}
          <div className={mediaContainer}>
            <DynamicMediaItem
              media={media}
              imageAspectRatio={useOriginalRatio ? 'original' : '16_9'}
              posterImage={posterImage}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphTextMedia;
